var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHsbc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#F7F6F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.069 120.67L160.002 80.469L120.069 40V120.67Z",
    fill: "#DB0011"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9338 40L80.1348 80.469L120.068 40H39.9338Z",
    fill: "#DB0011"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 80.469L39.933 120.67V40L0 80.469Z",
    fill: "#DB0011"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9338 120.67H120.068L80.1348 80.469L39.9338 120.67Z",
    fill: "#DB0011"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 80.67,
    fill: "white",
    transform: "translate(0 40)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHsbc);
export default __webpack_public_path__ + "static/media/hsbc.d5dbdc9a.svg";
export { ForwardRef as ReactComponent };